import validate from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/validate.js";
import i18n_45global from "/app/middleware/i18n.global.ts";
import router_45policy_45global from "/app/middleware/router-policy.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.110_eslint@9.28.0_less@4.3.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  i18n_45global,
  router_45policy_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}